import React from 'react';

// IDSMessageAvatar isn't available in this IDS version, so we replicate its look
// (a coloured circular user icon + label). `user` mirrors the IDSMessageAvatar
// convention: 1 = tester, 2 = reviewer.
const USER_COLORS = {
  1: 'var(--ids-palette-success-40, #37823a)',
  2: 'var(--ids-palette-accent-40, #0065bd)',
};

/**
 * Avatar header shown inside a comment bubble. Shared by the question and test
 * comment threads so both render identically.
 */
const CommentAvatar = ({ user = 1, label, subtitle }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.4rem' }}>
    <span
      aria-hidden="true"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '1.75rem',
        height: '1.75rem',
        borderRadius: '50%',
        flex: '0 0 auto',
        background: USER_COLORS[user] || USER_COLORS[1],
        color: '#fff',
      }}
    >
      <span className="ids-icon-user" style={{ fontSize: '1rem' }} />
    </span>
    <span style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.2 }}>
      <strong style={{ fontSize: '0.9rem' }}>{label}</strong>
      {subtitle && <span className="ids-small">{subtitle}</span>}
    </span>
  </div>
);

export default CommentAvatar;
